import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from 'app/modules/shared/services/notification.service';
import { UserAlertTypeModel, AlertModel } from 'app/modules/settings/interfaces/notification';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanDetailsListOfLoansService } from 'app/modules/shared/loan-details-modal/loan-details-list-of-loans.service';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { EmployeeService } from 'app/modules/shared/services/employee.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { ToastService } from 'app/modules/shared/services/toast.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationAlertDialogComponent } from 'app/modules/settings/components/confirmation-alert-dialog/confirmation-alert-dialog.component';
import { CurrentUserStateService } from 'app/modules/shared/services/current-user-state.service';
import { ImpersonationService } from 'app/modules/shared/services/impersonation.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
@Component({
    selector: 'app-profile-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
})
export class ProfileNotificationsComponent implements OnInit {
    deleteAllCheckbox: boolean;
    readAllCheckbox: boolean;
    readyToDelete: boolean;
    multipleSelected: boolean;
    mobileNumber: string;

    @ViewChild(TooltipDirective) kendoTooltip: TooltipDirective;

    constructor(
        private notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute,
        private listOfLoansService: LoanDetailsListOfLoansService,
        private _employeeService: EmployeeService,
        private toastService: ToastService,
        public dialog: MatDialog,
        private currentUserStateService: CurrentUserStateService,
        private impersonationService: ImpersonationService
    ) {}

    public tab: number;
    public alertTypes: UserAlertTypeModel[];
    public userNotifications: AlertModel[];
    notificationGridView: GridDataResult;
    alertGridView: GridDataResult;
    sortable = {
        mode: 'multiple',
        allowUnsort: true,
    };
    type: 'numeric' | 'input' = 'input';
    allResults: boolean = false;
    groupable = true;
    scrollable = 'scrollable';
    pageable = {
        refresh: true,
        info: true,
        type: this.type,
        previousNext: true,
        pageSizes: [5, 10, 25, 50],
    };
    isLoading: boolean;
    isLoadingAlertType: boolean;
    skip: 0;
    take: 10;
    notificationState: State = {
        skip: 0,
        take: 10,
    };
    alertTypeState: State = {
        skip: 0,
        take: 10,
    };
    AlertValueTypes = [
        '%LOAN_NUMBER',
        '%HIERARCHY_IDENTIFIER',
        '%PRODUCT_TYPE',
        '%GL_ACCOUNT_NUMBER',
    ];

    ngOnInit() {
        this.tab = 0;
        this.updateNotificationGrid();
        this.getUserTypes();
        this.getMobileNumber();
        this.router.onSameUrlNavigation = 'reload';
        let notificationAlert = this.notificationService.getNotificationAlert();
        if (notificationAlert) {
            this.alertClickHandler(notificationAlert);
            this.notificationService.clearNotificationAlert();
        }
    }

    updateNotificationGrid() {
        this.getNotifications();
    }

    getNotifications() {
        this.isLoading = true;
        this.notificationService.getNotifications().subscribe(
            (data) => {
                // filter out alerts that are not associated with an alertEvent, i.e. Daily summary
                let filteredNotifications = data.filter((event) => {
                    return event.alertEventKey > 0;
                });
                this.userNotifications = this.formatAlerts(filteredNotifications);

                this.loadUserNotifications();
                this.isLoading = false;
            },
            (error) => {
                this.isLoading = false;
                throw new Error(error);
            }
        );
    }

    loadUserNotifications() {
        this.notificationGridView = {
            data: process(this.userNotifications, this.notificationState).data,
            total: this.userNotifications.length,
        };
    }

    formatAlerts(notifications: AlertModel[]): AlertModel[] {
        for (let notification of notifications) {
            notification.alertDescription = this.insertAlertValue(notification);
        }

        return notifications;
    }

    formatAlertTypes(alertTypes: UserAlertTypeModel[]): UserAlertTypeModel[] {
        for (let type of alertTypes) {
            type.alertDescription = this.removeAlertPlaceholder(type.alertDescription);
        }

        return alertTypes;
    }

    insertAlertValue(notification: AlertModel): string {
        this.AlertValueTypes.forEach((el) => {
            if (notification.alertDescription.includes(el))
                notification.alertDescription = notification.alertDescription.replace(
                    el,
                    notification.alertValue ? notification.alertValue : ''
                );
        });
        return notification.alertDescription;
    }

    removeAlertPlaceholder(description: string): string {
        this.AlertValueTypes.forEach((el) => {
            if (description.includes(el)) {
                let replacementText = '';
                if (el === '%LOAN_NUMBER') {
                    replacementText = 'Loan';
                }
                description = description.replace(el, replacementText);
            }
        });
        return description;
    }

    getUserTypes(): void {
        this.isLoadingAlertType = true;
        this.notificationService.getUserNotificationTypes().subscribe(
            (data) => {
                this.alertTypes = this.formatAlertTypes(data);
                this.loadAlertTypes();
                this.isLoadingAlertType = false;
            },
            (error) => {
                this.isLoadingAlertType = false;
                throw new Error(error);
            }
        );
    }
    loadAlertTypes() {
        this.alertGridView = {
            data: process(this.alertTypes, this.alertTypeState).data,
            total: this.alertTypes.length,
        };
    }

    toggleRead(alert: AlertModel) {
        this.updateAlertStatus(alert);
    }

    /* Update the read status of a user notification */
    updateAlertStatus(alert: AlertModel): void {
        console.log('alert: ', alert);
        this.notificationService.updateAlert(alert).subscribe(
            () => {},
            (error) => {
                throw new Error(error);
            }
        );
    }

    /* Delete notification on click */
    deleteNotification(alert: AlertModel) {
        alert.isDeleted = true;
        this.notificationService.deleteAlert(alert.alertKey).subscribe(
            () => {
                this.updateNotificationGrid();
            },
            (error) => {
                throw new Error(error);
            }
        );
        // TODO: Add confirmation dialog before soft delete
    }

    alertClickHandler(notification: AlertModel) {
        if (notification.alertValue !== null && notification.alertType !== null) {
            notification.isRead = true;
            this.updateAlertStatus(notification);
            switch (notification.alertType.toLowerCase()) {
                case 'loannumber':
                    this.openLoanModal(notification.alertValue);
                    break;
                case 'hirereachy identier':
                    this.forceNavigation(`/directory/record/${notification.alertValue}`);
                    break;
                case 'product':
                    this.forceNavigation('/settings/client-product-mapping');
                    break;
                case 'glaccount':
                    this.forceNavigation('/settings/general-ledger-mapping');
                    break;
                default:
                    break;
            }
        }
    }

    forceNavigation(destinationRouteUrl: string): void {
        const defaultOnSameUrlNavigation = this.router.onSameUrlNavigation;
        this.router.onSameUrlNavigation = 'reload';
        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            return false;
        };
        this.router
            .navigateByUrl(destinationRouteUrl, {
                replaceUrl: true,
            })
            .then(() => {
                console.log('navigation complete.');
            })
            .catch((error) => {
                console.log(`navigation error: ${error}`);
            });

        this.router.onSameUrlNavigation = defaultOnSameUrlNavigation;
    }

    openLoanModal(identifier: string) {
        //identifier = "borrowerName(space)LoanNumber"

        //Put the loan number into an array
        let loanNumber = identifier.split(' ').pop();
        let index = 0;
        this.listOfLoansService.changeListOfLoans({
            loanNumbers: [loanNumber],
            index: index,
        });
        this.router.navigate([{ outlets: { modal: 'loanDetails' + '/' + loanNumber } }]);
    }

    public handleTabChange(event: MatTabChangeEvent): void {
        this.tab = event.index;
    }

    dataStateChange(state: DataStateChangeEvent): void {
        if (this.tab === 0) {
            this.notificationState = state;
            this.loadUserNotifications();
        } else {
            this.alertTypeState = state;
            this.loadAlertTypes();
        }
    }
    checkAll() {
        if (!!this.userNotifications) {
            this.deleteAllCheckbox = !this.deleteAllCheckbox;
            this.readyToDelete = this.deleteAllCheckbox;
            this.multipleSelected = this.multipleSelected;
            this.userNotifications.forEach((not) => {
                not.deleteCheckbox = this.deleteAllCheckbox;
            });
        }
    }

    checkAllRead() {
        if (!!this.userNotifications) {
            this.userNotifications.forEach((not) => {
                if (not.isRead !== this.readAllCheckbox) {
                    not.isRead = this.readAllCheckbox;
                    this.updateAlertStatus(not);
                }
            });
        }
    }
    checkChange(alert: AlertModel) {
        this.userNotifications.find(
            (userNotification) => userNotification.alertKey === alert.alertKey
        ).deleteCheckbox = !alert.deleteCheckbox;
        this.updateButtonAndCheckAll();
    }

    updateButtonAndCheckAll() {
        if (!!this.userNotifications) {
            let anyFalse =
                this.userNotifications.findIndex(
                    (userNotification) => !userNotification.deleteCheckbox
                ) !== -1
                    ? true
                    : false;
            let anyTrue =
                this.userNotifications.findIndex(
                    (userNotification) => userNotification.deleteCheckbox
                ) !== -1
                    ? true
                    : false;
            if (this.deleteAllCheckbox && anyFalse) this.deleteAllCheckbox = false;
            else if (!anyFalse) this.deleteAllCheckbox = true;

            if (!this.readyToDelete && anyTrue) this.readyToDelete = true;
            else if (this.readyToDelete && !anyTrue) this.readyToDelete = false;

            if (
                this.userNotifications.filter((userNotification) => userNotification.deleteCheckbox)
                    .length > 1
            )
                this.multipleSelected = true;
            else this.multipleSelected = false;
        } else {
            this.readyToDelete = false;
            this.deleteAllCheckbox = false;
        }
    }

    deleteChecked() {
        // let deltedNotifications = this.userNotifications.filter(
        //     (userNotification) => userNotification.deleteCheckbox
        // );

        // this.userNotifications = this.userNotifications.filter(
        //     (userNotification) => !userNotification.deleteCheckbox
        // );
        this.userNotifications.forEach((notification) => {
            notification.deleteCheckbox = true;
            this.deleteNotification(notification);
        });
    }

    toggleCheckbox(item: UserAlertTypeModel, field: string) {
        if (field === 'useText') {
            if (!this.profileHasMobileNumber()) {
                this.toastService.warning('Mobile number needed for text notifications.', {
                    location: '/settings/user-profile',
                    actionText: 'navigate',
                });
            } else if (item.useText) {
                this.showConfirmationDialog(item, field);
            } else {
                item[field] = !item[field];
                this.notificationService.upsertUserAlertType(item).subscribe(
                    () => {},
                    (error) => {
                        throw new Error(error);
                    }
                );
            }
        } else {
            item[field] = !item[field];
            this.notificationService.upsertUserAlertType(item).subscribe(
                () => {},
                (error) => {
                    throw new Error(error);
                }
            );
        }
    }

    getMobileNumber() {
        if (
            !this.currentUserStateService.isLBASuperUser ||
            this.impersonationService.isImpersonatingUser()
        )
            this._employeeService.getCurrentUsersEmployeeRecord().subscribe(
                (record) => {
                    this.mobileNumber = record.mobilePhone;
                },
                (err) => {
                    throw new Error(err);
                }
            );
        else {
            //LBA users dont have employee records so we need a default mobile number
            this.mobileNumber = '0000000000';
        }
    }

    profileHasMobileNumber(): boolean {
        return !!this.mobileNumber;
    }

    showConfirmationDialog(item: UserAlertTypeModel, field: string) {
        const dialogRef = this.dialog.open(ConfirmationAlertDialogComponent, {
            data: {
                title: 'Receive Text Messsages',
                message: `Are you sure you want to receive text messages to the number provided?`,
                value: this.mobileNumber,
                valueType: 'MobilePhone',
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result == 'accept') {
                item[field] = !item[field];
                this.notificationService.upsertUserAlertType(item).subscribe(
                    () => {},
                    (error) => {
                        throw new Error(error);
                    }
                );
            } else {
                this.clearGrid();
                this.getUserTypes();
            }
        });
    }
    clearGrid() {
        this.alertGridView = {
            data: [],
            total: 0,
        };
    }
}
